import React from 'react';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import { StyledEntityLogoBox } from './styled.js';

const EntityLogoTile = ({ data }) => (
  <StyledEntityLogoBox>
    <EntityItem data={data} />
  </StyledEntityLogoBox>
);

export default EntityLogoTile;
